// my datatatatat
import React, { Component } from 'react';
/* eslint-disable */

import App_data from '../../../config/App_data';
import FD from '../../../RestAPI/fetchData';

import language from '../../../../assets/languages/language';
import AppRoutes from '../../../config/AppRoutes';
import ValidateSaveReportIcon from '../../../Common/ValidateSaveReportIcon';
import StarRatings from 'react-star-ratings';
import Loader from '../../../../common/loader';
import GMATCalculator from '../../../../common/Calculator/GMATCalculator';
import { renderHTMLContent } from '../../../../common/function';
var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
// let tableRegex = /(<table[^>]*>(?:.|\n)*(?=<\/table>))/g;
const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: '',
      idname: '',
      data: [],
      question: '',
      statement1: '',
      statement2: '',
      statement3: '',
      choice1: '',
      choice2: '',
      choice3: '',
      error: '',
      sortElement: [],
      chapter_id: this.props.params.chapterid,
      reading_id: this.props.params.readingid,
      offset: this.props.params.offset,
      explanation: '',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      save_text: `${language.LC().SAVE_QUESTION}`,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      report_block: 'card hide_block',
      text_color: 'card-header',
      result: '',
      reportLoading: false,
      result_block: 'card hide_block',
      questionsArray: [],
      subscriptionstatus: parseInt(this.props.params.subscription, 10) ? 'paid' : 'free',
      reading: this.props.params.reading,
      display_loader: 'show_block',
      questionHide: 'hide_block',
      answer1: '',
      answer2: '',
      answer3: '',
      choice1_yes: '',
      choice2_yes: '',
      choice3_yes: '',
      choice1_no: '',
      choice2_no: '',
      choice3_no: '',
    };

    // http://reactkungfu.com/2015/07/why-and-how-to-bind-methods-in-your-react-component-classes/
    // bind the context for compareBy & sortBy to this component instance
    this.compareBy.bind(this);
    this.sortBy.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
  }

  compareBy(key) {
    return function (a, b) {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
      return 0;
    };
  }
  componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      reading_id: this.props.params.readingid,
      question_type: 'table_question',
      subscriptionstatus: parseInt(this.props.params.subscription, 10) ? 'paid' : 'free',
    };
    FD.callAPI(
      App_data.backend_api + '/gmat_question_bank/getSpecialQuestionByReadingId',
      data,
    ).then(async resp => {
      if (resp.success) {
        let { offset } = this.state;
        this.setState({
          questionsArray: resp.result,
        });
        this.setQuestionData(resp.result, offset);
      }
      console.log('questioooonn array', this.state.questionsArray);
    });
  }

  getFavQuestions = questionid => {
    var params_fav = {
      token: this.state.token,
      question_id: questionid,
      idname: this.state.idname,
      chapter_id: this.props.params.chapterid,
      type: 'table_question',
    };
    console.log('I am inside get Fav question', questionid);
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavQuestions', params_fav).then(
      response => {
        if (response.success) {
          this.setState({
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
            save_text: `${language.LC().Question_Saved}`,
          });
        }
      },
    );
  };

  getGMATRatting = questionid => {
    var params = {
      token: this.state.token,
      question_id: questionid,
      idname: this.state.idname,
      type: 'tab_question',
    };
    //Api to get ratting
    console.log('I am inside get Fav question', questionid);
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getGMATRatting', params).then(
      response => {
        if (response.success) {
          this.setState({ rated: true });
          response.ratting.map(items =>
            this.setState({
              rating: items.ratting,
              ratting_text: 'Rated ',
            }),
          );
        }
      },
    );
  };

  setQuestionData = (questionsArray, offset) => {
    let questionObj = questionsArray[offset || 0];
    if (questionObj) {
      this.setState(
        {
          question: questionObj.question.split('<table')
            ? questionObj.question.split('<table')[0]
            : questionObj.question,
          tableData: `<table id="myTable" border="1" cellpadding="5px" ${questionObj.question.split('<table')
            ? questionObj.question.split('<table')[1]
            : questionObj.question
            }`,
          sortElement: questionObj.sortBy ? questionObj.sortBy.split(',') : [],
          explanation: questionObj.explanation ? questionObj.explanation.split(',') : [],
          statement1: questionObj.option1,
          statement2: questionObj.option2,
          statement3: questionObj.option3,
          answer1: questionObj.answer1,
          answer2: questionObj.answer2,
          answer3: questionObj.answer3,
          questionId: questionObj.id,
          offset,
          display_loader: 'hide_block',
          questionHide: '',
          choice1: '',
          choice2: '',
          choice3: '',
          choice1_yes: '',
          choice2_yes: '',
          choice3_yes: '',
          choice1_no: '',
          choice2_no: '',
          choice3_no: '',
          correct_heading: questionObj.choice_a,
          incorrect_heading: questionObj.choice_b,
          result_block: 'card hide_block',
          report_block: 'card hide_block',
        },
        () => {
          this.getFavQuestions(questionObj.id);
          this.getGMATRatting(questionObj.id);
        },
      );
    }
  };

  //Function to check Right Or Wrong Answered and displayed clicked box
  _getAnswer = (choice, e) => {
    this.setState({ clicked: true });
    this.setState({ choice: choice });
    // const result = getDeviceDetails();

    if (choice === 'choice_a') {
      this.setState({ choice_a: 'answer_box clicked_box' });
      this.setState({ choice_b: 'answer_box' });
      this.setState({ choice_c: 'answer_box' });
      this.setState({ choice_d: 'answer_box' });
      this.setState({ choice_e: 'answer_box' });
    } else if (choice === 'choice_b') {
      this.setState({ choice_b: 'answer_box clicked_box' });
      this.setState({ choice_a: 'answer_box' });
      this.setState({ choice_c: 'answer_box' });
      this.setState({ choice_d: 'answer_box' });
      this.setState({ choice_e: 'answer_box' });
    } else if (choice === 'choice_c') {
      this.setState({ choice_c: 'answer_box clicked_box' });
      this.setState({ choice_a: 'answer_box' });
      this.setState({ choice_b: 'answer_box' });
      this.setState({ choice_d: 'answer_box' });
      this.setState({ choice_e: 'answer_box' });
    } else if (choice === 'choice_d') {
      this.setState({ choice_d: 'answer_box clicked_box' });
      this.setState({ choice_a: 'answer_box' });
      this.setState({ choice_b: 'answer_box ' });
      this.setState({ choice_c: 'answer_box' });
      this.setState({ choice_e: 'answer_box' });
    } else if (choice === 'choice_e') {
      this.setState({ choice_e: 'answer_box clicked_box' });
      this.setState({ choice_a: 'answer_box' });
      this.setState({ choice_b: 'answer_box' });
      this.setState({ choice_c: 'answer_box' });
      this.setState({ choice_d: 'answer_box' });
    }
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      id: this.props.params.id,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/trackUserRecord', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
      }
    });
  };

  _getResult = async (item, e) => {
    let { choice1, choice2, choice3, answer1, answer2, answer3 } = this.state;
    let expectedCount = 3;
    let count = 0;
    if (choice1 && choice2 && choice3) {
      let count = 0;
      if (choice1.toLowerCase().trim() === answer1.toLowerCase().trim()) {
        count++;
        if (choice1.toLowerCase().trim() === 'yes') {
          this.setState({
            choice1_yes: 'accent-success',
          });
        } else {
          this.setState({
            choice1_no: 'accent-success',
          });
        }
      } else {
        if (choice1.toLowerCase().trim() === 'yes') {
          this.setState({
            choice1_yes: 'accent-faliure',
          });
        } else {
          this.setState({
            choice1_no: 'accent-faliure',
          });
        }
      }
      if (choice2.toLowerCase().trim() === answer2.toLowerCase().trim()) {
        count++;
        if (choice2.toLowerCase().trim() === 'yes') {
          this.setState({
            choice2_yes: 'accent-success',
          });
        } else {
          this.setState({
            choice2_no: 'accent-success',
          });
        }
      } else {
        if (choice2.toLowerCase().trim() === 'yes') {
          this.setState({
            choice2_yes: 'accent-faliure',
          });
        } else {
          this.setState({
            choice2_no: 'accent-faliure',
          });
        }
      }
      if (choice3.toLowerCase().trim() === answer3.toLowerCase().trim()) {
        count++;
        if (choice3.toLowerCase().trim() === 'yes') {
          this.setState({
            choice3_yes: 'accent-success',
          });
        } else {
          this.setState({
            choice3_no: 'accent-success',
          });
        }
      } else {
        if (choice3.toLowerCase().trim() === 'yes') {
          this.setState({
            choice3_yes: 'accent-faliure',
          });
        } else {
          this.setState({
            choice3_no: 'accent-faliure',
          });
        }
      }
      let right_answer = 0;
      if (expectedCount === count) {
        right_answer = 1;
        this.setState({
          result: 'CORRECT',
          text_color: 'card-header text_success',
          result_block: 'card show_block',
        });
      } else {
        this.setState({
          result_block: 'card show_block',
          result: 'INCORRECT',
          text_color: 'card-header text_failure',
        });
      }
      // --------------- Save Stat API call Start -----------//
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        question_id: this.state.questionId,
        right_answer: right_answer,
        type: 'table_question',
        // time_done: this.state.count,
      };

      await FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveStats', data).then(
        async resp => {
          if (resp.success) {
            this.setState({ ValidToken: true, validated: true });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        },
      );

      // --------------- Save Stat API call End-----------//
    } else {
      console.log('I am inside else ');
    }
    if (expectedCount === 3) {
      if (choice1 && choice2 && choice3) {
        this.setState({
          error: '',
        });
      } else {
        this.setState({
          error: 'Please select all the options',
        });
      }
    }
  };

  //Function to fetch previous question
  _getPrevious = () => {
    this.setState({
      display_loader: 'show_block',
      validated: false,
      rated: false,
      rating: 0,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      save_text: `${language.LC().SAVE_QUESTION}`,
      timerstopbtn: 'pause_btn icon-control-pause',
      report_block: 'card hide_block',
      choice_name: '',
      bookmarkColor: '',
    });
    if (this.state.error) {
      this.setState({
        error: '',
      });
    } else {
      console.log('else');
    }
    document.getElementById('comment').value = '';
    this.setRadioButtonBlank();
    let offset = parseFloat(this.state.offset) - 1;
    const { questionsArray, reading } = this.state;
    this.setQuestionData(questionsArray, offset);
    this.context.router.push({
      pathname: AppRoutes.GMAT_TABLE.replace(':chapterid', this.state.chapter_id)
        .replace(':readingid', this.state.reading_id)
        .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
        .replace(':question_id', questionsArray[offset || 0].id)
        .replace(':offset', offset)
        .replace(':reading', reading),
    });
    // window.location.reload();
  };
  setRadioButtonBlank = () => {
    for (let counter = 0; counter < 5; counter++) {
      let resetRadioButton = document.getElementsByName(`choice${counter + 1}`);
      for (var i = 0; i < resetRadioButton.length; i++) resetRadioButton[i].checked = false;
    }
    document.getElementById('table_data_select').selectedIndex = 0;
  };
  //Function to fetch Next question
  _getNext = () => {
    this.setState({
      display_loader: 'show_block',
      validated: false,
      rated: false,
      rating: 0,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      save_text: `${language.LC().SAVE_QUESTION}`,
      timerstopbtn: 'pause_btn icon-control-pause',
      report_block: 'card hide_block',
      choice_name: '',
      bookmarkColor: '',
    });
    if (this.state.error) {
      this.setState({
        error: '',
      });
    } else {
      console.log('else');
    }
    this.setRadioButtonBlank();
    document.getElementById('comment').value = '';
    let offset = parseFloat(this.state.offset) + 1;
    const { questionsArray, reading } = this.state;
    this.setQuestionData(questionsArray, offset);
    this.context.router.push({
      pathname: AppRoutes.GMAT_TABLE.replace(':chapterid', this.state.chapter_id)
        .replace(':readingid', this.state.reading_id)
        .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
        .replace(':question_id', questionsArray[offset || 0].id)
        .replace(':offset', offset)
        .replace(':reading', reading),
    });
    // window.location.reload();
  };

  /*
  ------------------------------------------------------------------------
     Function to Display Saved Question on button and save in database
  -------------------------------------------------------------------------
    */
  _saveQuestion = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: this.state.questionId,
      chapter_id: this.props.params.chapterid,
      type: 'table_question',
      topic_name: this.state.reading,
      reading_id: this.props.params.readingid,
    };
    if (this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
      // return;
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
            bookmarkColor: '',
            save_text: `${language.LC().SAVE_QUESTION}`,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    } else {
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveQuestion', data).then(resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
            save_text: `${language.LC().Question_Saved}`,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    }
  };

  //Function to hide Report box
  _hideReportForm = (item, e) => {
    this.setState({ report_block: 'card hide_block' });
  };

  /*
  -------------------------------------------
    Funcion to save new report question
  -------------------------------------------
    */
  _reportQuestion = (item, e) => {
    var comment = document.getElementById('comment').value;
    if (comment.length < 2) {
      return;
    }
    // const result = getDeviceDetails();
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: this.state.questionId,
      comment: comment,
      caseIndex: this.props.params.case_offset,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
      type: 'table_question',
      topic_name: this.state.reading,
      reading_id: this.props.params.readingid,
    };
    this.setState({
      reportLoading: true,
    });
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/reportQuestion', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          successAlert: true,
          reportLoading: false,
        });
        document.getElementById('comment') ? (document.getElementById('comment').value = '') : '';
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };
  /*
  --------------------------------------
    Function to show Report box
  -------------------------------------
    */
  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };

  /*
  -------------------------------------
    Function to give star rattings
  -------------------------------------
    */
  onStarClick(item, nextValue, prevValue, name) {
    if (prevValue !== nextValue) {
      let params = {
        token: this.state.token,
        idname: this.state.idname,
        question_id: this.state.questionId,
        ratting: nextValue,
        type: 'table_question',
      };
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/UpdateGMATRatting', params).then(
        response => {
          if (response.success) {
            this.setState({ rated: 1, ratting_text: 'Rated ' });
          }
        },
      );
    }

    this.setState({ rating: nextValue });
    let params = {
      token: this.state.token,
      question_id: item.id,
      idname: this.state.idname,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getGMATRatting', params).then(
      response => {
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: this.state.questionId,
          ratting: nextValue,
          type: 'table_question',
        };
        if (response.success) {
          if (response.ratting.length > 0) {
            this.setState({ rated: true });
            response.ratting.map(items =>
              this.setState({ rating: items.ratting, ratting_text: 'Rated ' }),
            );
          } else {
            FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(
              response => {
                if (response.success) {
                  this.setState({ rated: 1, ratting_text: 'Rated ' });
                }
              },
            );
          }
        } else {
          FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(
            response => {
              if (response.success) {
                this.setState({
                  rated: 1,
                  ratting_text: `Rated ${nextValue} stars`,
                });
              }
            },
          );
        }
      },
    );
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  //Function to redirect page to readings page
  _getReadings = () => {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUESTION_BANK_READING.replace(':id', this.props.params.chapterid),
    });
  };

  _getQuestions = () => {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUESTION_BANK_LIST_QUE.replace(
        ':chapter_no',
        this.props.params.chapterid,
      )
        .replace(':id', this.props.params.readingid)
        .replace(':subscriptionstatus', this.state.subscriptionstatus)
        .replace(':reading', this.state.reading),
    });
  };

  //Function to show calculator
  _handleModal = () => {
    this.setState({
      show: true,
    });
  };

  sortBy(key) {
    let arrayCopy = [...this.state.data];
    arrayCopy.sort(this.compareBy(key));
    this.setState({ data: arrayCopy });
  }

  onChangeValue(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
      [`${name}_yes`]: '',
      [`${name}_no`]: '',
    });
  }
  sortTable(value, e) {
    let index = value;
    // this.state.sortElement.find((element, i) => {
    //   if (element === value) index = i;
    // });
    var table, rows, switching, i, x, y, shouldSwitch;
    table = document.getElementById('bodyData');
    switching = true;
    /*Make a loop that will continue until
  no switching has been done:*/
    let firstValue, secondValue;
    while (switching) {
      //start by saying: no switching is done:
      switching = false;
      rows = table.rows;
      /*Loop through all table rows (except the
    first, which contains table headers):*/
      for (i = 0; i < rows.length - 1; i++) {
        //start by saying there should be no switching:
        shouldSwitch = false;
        /*Get the two elements you want to compare,
      one from current row and one from the next:*/
        x = rows[i].getElementsByTagName('TD')[index];
        y = rows[i + 1].getElementsByTagName('TD')[index];
        //check if the two rows should switch place:
        if (x !== undefined && y !== undefined) {
          firstValue = parseFloat(x.innerHTML.replace(/[>,<]/gm, '').replace(/&[gl]t;/gm, ''));
          secondValue = parseFloat(y.innerHTML.replace(/[>,<]/gm, '').replace(/&[gl]t;/gm, ''));
          if (isNaN(firstValue)) {
            firstValue = x.innerHTML.toLowerCase().trim();
            firstValue = specialChars.test(firstValue) ? '0' : firstValue;
          }
          if (isNaN(secondValue)) {
            secondValue = y.innerHTML.toLowerCase().trim();
            secondValue = specialChars.test(secondValue) ? '0' : secondValue;
          }
          if (isNaN(firstValue) !== isNaN(secondValue)) {
            if (isNaN(firstValue)) firstValue = 0;
            if (isNaN(secondValue)) secondValue = 0;
          }
          if (firstValue === secondValue) {
            let repGtx = x.innerHTML.toLowerCase().replace('&gt;', '>');
            let repGty = y.innerHTML.toLowerCase().replace('&gt;', '>');
            let repltx = x.innerHTML.toLowerCase().replace('&lt;', '<');
            let replty = y.innerHTML.toLowerCase().replace('&lt;', '<');
            if (repGtx.includes('>') && !repGty.includes('>')) {
              shouldSwitch = true;
              break;
            }
            if (!repltx.includes('<') && replty.includes('<')) {
              shouldSwitch = true;
              break;
            }
          }
          if (firstValue > secondValue) {
            //if so, mark as a switch and break the loop:
            shouldSwitch = true;
            break;
          }
        }
      }
      if (shouldSwitch) {
        /*If a switch has been marked, make the switch
      and mark that a switch has been done:*/
        rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
        switching = true;
      }
    }
  }
  resetTableContent = () => {
    const { questionsArray, offset } = this.state;
    let questionObj = questionsArray[offset || 0];
    this.setState(
      {
        tableData: '',
      },
      () => {
        this.setState({
          tableData: `<table id="myTable" border="1" cellpadding="5px" ${questionObj.question.split('<table')
            ? questionObj.question.split('<table')[1]
            : questionObj.question
            }`,
        });
        document.getElementById('table_data_select').selectedIndex = 0;
      },
    );
  };
  onClose = e => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };
  render() {
    const {
      statement1,
      statement2,
      statement3,
      correct_heading,
      incorrect_heading,
      question,
      tableData,
      explanation,
      reportLoading,
      questionsArray,
      offset,
      reading,
      display_loader,
      questionHide,
      choice3_yes,
      choice3_no,
      choice1_yes,
      choice1_no,
      choice2_yes,
      choice2_no,
      questionId,
      error,
    } = this.state;
    return (
      <div>
        {/* ---------- Header ---------- */}
        <div className='margin_bottom_20 d-flex justify-content-between'>
          <div>
            <h1 className='section_head'>{language.LC().QUESTION_BANK}</h1>
          </div>
          <div>
            <button
              type='button'
              className='btn btn-primary pointer_class calc-btn'
              onClick={this._handleModal}
            >
              {language.LC().OPEN_CALCULATOR}
            </button>
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getQuestions}
            >
              {language.LC().CHANGE_QUESTIONS}
            </button>

            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getReadings}
            >
              {language.LC().CHANGE_READING}
            </button>
          </div>
        </div>
        <div className={`card margin_bottom_40 ${questionHide}`}>
          {/* ----------- Heading ----------- */}
          <div className='card-header'>
            <img
              src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
              className='margin_right_20'
              width='30'
              alt=''
            />
            {renderHTMLContent(reading, "span", "", { contentEditable: 'false' })} (
            {language.LC().Q} {questionId})
            <div className='float-right text-right'>
              {parseInt(offset) !== 0 ? (
                <i
                  className={'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block}
                  onClick={this._getPrevious}
                />
              ) : null}
              {questionsArray.length - 1 !== parseInt(offset) ? (
                <i
                  className={'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block}
                  onClick={this._getNext}
                />
              ) : null}
            </div>
          </div>
          {/* ---------- Body ------------- */}
          <div className='card-block font-16px statement-question-div'>
            {/* <div className='d-flex'>
              <div
                className='flex-basis-50'
                style={{
                  borderRight: '1px solid #f5f5f5',
                  paddingRight: '1rem',
                }}
              > */}
            {renderHTMLContent(question, "div", "text-justify")}
            <div className='d-flex mt-1 align-items-center mb-1'>
              {/* <div className='d-flex'> */}
              <h5 className='m-0  font-weight-bold'>Sort By :</h5>
              <select
                name='table_data_select'
                id='table_data_select'
                // onChange={(e) => this.sortBy(e.target.value)}
                onChange={e => this.sortTable(e.target.value)}
                className='h-min-content ml-35px w-lg-30 w-sm-50'
              >
                <option selected='selected' disabled='disabled' value='DEFAULT'>
                  Select...
                </option>
                {this.state.sortElement && this.state.sortElement.length
                  ? this.state.sortElement.map((value, index) => (
                    <option
                      key={index}
                      value={index}
                      // onChange={() => this.sortBy(value)}
                      onChange={() => this.sortTable(index, value)}
                    >
                      {/* {value} */}
                      {renderHTMLContent(value, "span")}
                    </option>
                  ))
                  : null}
              </select>
              {/* </div> */}
              <span className='up tooltip-hover-questions ml-1'>
                <div className='tootip_box'> Reset </div>
                <button
                  type='submit'
                  className='btn btn-circle btn-refresh pointer_class'
                  id='Tooltip-2'
                  onClick={this.resetTableContent}
                >
                  <i className='fa fa-refresh p-0' aria-hidden='true' />
                </button>
              </span>
            </div>
            {renderHTMLContent(tableData, "div", "overflow-x-auto table-w-100")}

            {/* </div> */}

            <form onSubmit={this.submit}>
              <table>
                <tr>
                  <th>{correct_heading}</th>
                  <th>{incorrect_heading}</th>
                  <th />
                </tr>
                <tr onChange={this.onChangeValue}>
                  <td>
                    <input
                      type='radio'
                      id='html'
                      name='choice1'
                      value='Yes'
                      className={`${choice1_yes}  pointer_class`}
                    />
                  </td>
                  <td>
                    <input
                      type='radio'
                      id='html'
                      name='choice1'
                      value='No'
                      className={`${choice1_no}  pointer_class`}
                    />
                  </td>
                  <td>{statement1}</td>
                </tr>
                <tr onChange={this.onChangeValue}>
                  <td>
                    <input
                      type='radio'
                      id='html'
                      name='choice2'
                      value='Yes'
                      className={`${choice2_yes} pointer_class`}
                    />
                  </td>
                  <td>
                    <input
                      type='radio'
                      id='html'
                      name='choice2'
                      value='No'
                      className={`${choice2_no}  pointer_class`}
                    />
                  </td>
                  <td>{statement2}</td>
                </tr>
                <tr onChange={this.onChangeValue}>
                  <td>
                    <input
                      type='radio'
                      id='html'
                      name='choice3'
                      value='Yes'
                      className={`${choice3_yes} pointer_class`}
                    />
                  </td>
                  <td>
                    <input
                      type='radio'
                      id='html'
                      name='choice3'
                      value='No'
                      className={`${choice3_no}  pointer_class`}
                    />
                  </td>
                  <td>{statement3}</td>
                </tr>
              </table>
            </form>
            {/* ----------------- Validate and Rate Question */}
            <p className='error_msg1'>{error}</p>
            <div className='row bottom-tool mt-1'>
              <ValidateSaveReportIcon
                isQue={true}
                _getResult={this._getResult}
                _saveQuestion={this._saveQuestion}
                _displayReportForm={this._displayReportForm}
                all_questions={question}
                save_text={this.state.save_text}
                bookmarkCSS={this.state.bookmarkCSS}
                bookmarkColor={this.state.bookmarkColor}
              // isSpecialQuestion={true}
              />
              <div className='col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right'>
                <div className='star_rating_wrap'>
                  <span className=' margin_bottom_0 margin_right_10'>
                    {this.state.ratting_text}
                  </span>
                  <StarRatings
                    rating={this.state.rating}
                    starRatedColor='rgb(255, 180, 0)'
                    starEmptyColor='rgb(51, 51, 51)'
                    starDimension='20px'
                    starHoverColor='rgb(255, 180, 0)'
                    starSpacing='2px'
                    changeRating={this.onStarClick.bind(this, question)}
                    numberOfStars={5}
                    name='rate1'
                  />
                </div>
              </div>
            </div>
            {/* </div> */}
          </div>
        </div>
        {/* --------- Explanation popup -------*/}
        <div className={`${this.state.result_block} font-lusitana font-16px`}>
          <div className={this.state.text_color}>{this.state.result}</div>
          <div className='card-block'>
            {renderHTMLContent(
              explanation,
              "p",
              "view_questionhtml",
              { contentEditable: 'false' }
            )}
          </div>
        </div>
        {/* ---------- Report ----------- */}
        <div className={this.state.report_block}>
          <div className='card-header'>{language.LC().REPORT}</div>
          {!this.state.successAlert ? (
            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-12'>
                  <label className='form-control-label' htmlFor='textarea-input'>
                    <strong> {language.LC().COMMENT}</strong>
                  </label>
                </div>
                <div className='col-sm-12 margin_bottom_10'>
                  <textarea
                    id='comment'
                    name='comment'
                    rows='6'
                    className='form-control'
                    placeholder='Content..'
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12'>
                  <button
                    type='button'
                    className='btn btn-primary active pointer_class report-btn'
                    disabled={reportLoading}
                    onClick={this._reportQuestion.bind(this, question)}
                  >
                    {' '}
                    {reportLoading ? language.LC().PLEASE_WAIT : language.LC().REPORT}
                  </button>
                  <button
                    type='button'
                    className='btn btn-danger active pointer_class margin_left_10'
                    onClick={this._hideReportForm.bind(this, question)}
                  >
                    {' '}
                    {language.LC().CANCEL}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-12 report-Success-card'>
                  <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                  <label className='form-control-label' htmlFor='textarea-input'>
                    <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                  </label>
                  <button
                    type='button'
                    className='btn btn-primary active pointer_class  min-vw-120'
                    onClick={this.onClose}
                  >
                    {' '}
                    {language.LC().CLOSE}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* ---------- Loader ----------- */}
        {display_loader === 'show_block' ? <Loader /> : null}
        <GMATCalculator
          addToInput={this.addToInput}
          show={this.state.show}
          addDecimal={this.addDecimal}
          addZeroToInput={this.addZeroToInput}
          clearInput={this.clearInput}
          add={this.add}
          subtract={this.subtract}
          multiply={this.multiply}
          divide={this.divide}
          evaluate={this.evaluate}
          closeModal={() => this.setState({ show: false })}
        />
      </div>
    );
  }
}

export default Table;



// WEBPACK FOOTER //
// ./src/views/GMAT/QuestionBank/SpecialQuestions/GMATTable.js